import { defineComponent as r } from "vue";
import { submitInternalEvent as e } from "@ado/tracking-library";
import { useNavigationEventBus as m } from "@ado/acs-standard-library";
import { TRACKING_EVENTS as p } from "../../../shared/data/tracking/types/index.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { setShowPolicyDialog as n } from "../../../shared/data/layout/state/index.js";
import { PolicyDialogType as a } from "../../../shared/data/layout/state/index4.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import { useBaseApplicationTranslation as s } from "../../../shared/libraries/local-translations/index.js";
const I = r({
  name: "FooterMobileLinks",
  props: {
    isOnSelectionPage: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    const o = m(), t = () => {
      e(p.FOOTER_ABOUT_CLICK), o.navigate("/about.php", "_self");
    }, { t: i } = s();
    return {
      aboutPage: t,
      setShowPolicyDialog: n,
      PolicyDialogType: a,
      t: i
    };
  }
});
export {
  I as default
};
//# sourceMappingURL=index30.js.map
